import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { ResetPasswordService } from '@ml/auth/services';
import { catchError, map } from 'rxjs/operators';
import { SharedService } from '@ml/shared/services/shared.service';

@Injectable()
export class ResetPasswordGuard implements CanActivate {
  constructor(
    private resetPasswordService: ResetPasswordService,
    private router: Router,
    private sharedService: SharedService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const resetToken: string = next.queryParamMap.get('token');

    if (!resetToken) {
      this.router.navigate(['auth']);
      return false;
    }

    return this.resetPasswordService.tokenValidation(resetToken).pipe(
      map(() => {
        this.resetPasswordService.setResetToken(resetToken);
        return true;
      }),
      catchError(() => {
        this.sharedService.showMessage(
          'Reset password link invalid!',
          null,
          null,
          'Close'
        );
        this.router.navigate(['auth']);
        return of(false);
      })
    );
  }
}
